<div class="header">
  <ng-content select="[header]"></ng-content>
</div>

<div class="table-outer-container">
  <div class="table-inner-container mat-elevation-z8">
    <div class="table-scroll-container">
      <ng-content select="[mat-table]"></ng-content>
    </div>

    <ng-content select="mat-paginator"></ng-content>
    <ng-content select="dt-table-footer"></ng-content>

    @if (isLoading) {
      <div class="loading-shade">
        <mat-spinner [diameter]="42"></mat-spinner>
      </div>
    }
  </div>
</div>
